// External imports
import axios from 'axios'
import endPoints from '../../_services/endpoints'

// Create Redux action types
export const GET_CLIENTS = 'GET_CLIENTS'
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS'
export const GET_CLIENTS_FAILURE = 'GET_CLIENTS_FAILURE'
export const ADD_CLIENT = "ADD_CLIENT"
export const ADD_CLIENT_FAILURE = "ADD_CLIENT_FAILURE"
export const EDIT_CLIENT = "EDIT_CLIENT"
export const EDIT_CLIENT_FAILURE = "EDIT_CLIENT_FAILURE"

// Create Redux action creators that return an action
export const getClients = () => ({
    type: GET_CLIENTS,
})

export const getClientsSuccess = clients => ({
    type: GET_CLIENTS_SUCCESS,
    payload: clients,
})

export const getClientsFailure = () => ({
    type: GET_CLIENTS_FAILURE,
})

// Combine them all in an asynchronous thunk
export function fetchClients() {
    return async dispatch => {
        dispatch(getClients())

        try {
            if(!localStorage.getItem("clients")){
                const loggedInUserData = JSON.parse(localStorage.getItem('userData'));
            if (loggedInUserData) {
                if (loggedInUserData.Token) {
                    axios.defaults.headers['ApplicationSecurityCode'] = loggedInUserData.ApplicationSecurityCode;
                    axios.defaults.headers.common['SECURIT_IDENTITY'] = loggedInUserData.Token;
                }
            }
            const response = await axios.get(endPoints.allClients)
            const data = await response.data
            data.map(client => {
                if (client.InActiveFlag === "Y") {
                    client.InActiveFlag = "Inactive"
                } else {
                    client.InActiveFlag = "Active"
                }
                return client
            })

            localStorage.setItem("clients",JSON.stringify(data));
            dispatch(getClientsSuccess(data))
            } else {
                let data = JSON.parse(localStorage.getItem("clients"))
                if(data === null){
                    data =[];
                }
                dispatch(getClientsSuccess(data))
            }
            
        } catch (error) {
            dispatch(getClientsFailure())
        }
    }
}

// Add client fn
export const addClientSuccess = client => ({
    type: ADD_CLIENT,
    payload: client,
})
export const addClientFailure = () => ({
    type: ADD_CLIENT_FAILURE,
})

export function addClient(client) {
    return async dispatch => {
        dispatch(getClients())
        const loggedInUserData = JSON.parse(localStorage.getItem('userData'));
        if (loggedInUserData) {
            if (loggedInUserData.Token) {
                axios.defaults.headers['ApplicationSecurityCode'] = loggedInUserData.ApplicationSecurityCode;
                axios.defaults.headers.common['SECURIT_IDENTITY'] = loggedInUserData.Token;
            }
        }
        await axios.post(endPoints.addClient, {
            ClientName: client.ClientName,
            ClientDescription: client.ClientDescription,
            InActiveFlag: client.InActiveFlag,
            CreatedBy: client.CreatedBy,
            ModifiedBy: client.ModifiedBy
        }).then(res => {
            if (client.InActiveFlag === "Y") {
                client.InActiveFlag = "Inactive"
            } else {
                client.InActiveFlag = "Active"
            }
            dispatch(addClientSuccess(client))
            dispatch(fetchClients())
        }).catch(error => {
            dispatch(addClientFailure())
        })
    }
};

// Update client fn
export const editClientSuccess = client => ({
    type: EDIT_CLIENT,
    payload: client,
})
export const editClientFailure = () => ({
    type: EDIT_CLIENT_FAILURE,
})

export function editClient(client) {
    return async dispatch => {
        dispatch(getClients())
        const loggedInUserData = JSON.parse(localStorage.getItem('userData'));
        if (loggedInUserData) {
            if (loggedInUserData.Token) {
                axios.defaults.headers['ApplicationSecurityCode'] = loggedInUserData.ApplicationSecurityCode;
                axios.defaults.headers.common['SECURIT_IDENTITY'] = loggedInUserData.Token;
            }
        }
        await axios.post(endPoints.updateClient, {
            Id: client.Id,
            ClientName: client.ClientName,
            ClientDescription: client.ClientDescription,
            InActiveFlag: client.InActiveFlag,
            ModifiedBy: client.ModifiedBy
        }).then(res => {
            if (client.InActiveFlag === "Y") {
                client.InActiveFlag = "Inactive"
            } else {
                client.InActiveFlag = "Active"
            }
            dispatch(editClientSuccess(client))
        }).catch(error => {
            dispatch(editClientFailure())
        })
    }
};